import { render, staticRenderFns } from "./BehaviourLogManagement.vue?vue&type=template&id=0cfa683c&scoped=true"
import script from "./BehaviourLogManagement.vue?vue&type=script&lang=js"
export * from "./BehaviourLogManagement.vue?vue&type=script&lang=js"
import style0 from "./BehaviourLogManagement.vue?vue&type=style&index=0&id=0cfa683c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cfa683c",
  null
  
)

export default component.exports